  document.addEventListener('click', function (e) {
    const acc = e.target.closest('.faq-accordion');
    if (!acc) return;

    acc.classList.toggle('active');

    const panel = acc.nextElementSibling;
    if (!panel) return;

    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  });
